import { ReactElement } from 'react';

import {
  SmallInternship,
  LargeInternship,
} from '@backrs_ui/common-ui/src/molecules/Nugget/NuggetInternship/types';

import { NuggetInternshipLarge } from './NuggetInternshipLarge';
import { NuggetInternshipSmall } from './NuggetInternshipSmall';

type NuggetInternshipProps = Readonly<{
  variant: SmallInternship | LargeInternship;
  contentSize?: 'SMALL' | 'LARGE';
}>;

export const NuggetInternship = ({
  variant,
  contentSize,
}: NuggetInternshipProps): ReactElement | null => {
  if (variant.type === 'SMALL') {
    return <NuggetInternshipSmall variant={variant} contentSize={contentSize} />;
  }

  return <NuggetInternshipLarge internshipInfo={variant.internshipInfo} />;
};
